'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var errors = require('./errors');

var debug = require('debug');

var log = debug('repo:lock');
var lockFile = 'repo.lock';
var LOCKS = {};
/**
 * Lock the repo in the given dir.
 *
 * @param {string} dir
 * @returns {Promise<Object>}
 */

exports.lock = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dir) {
    var file, closer;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // eslint-disable-line require-await
            file = dir + '/' + lockFile;
            log('locking %s', file);

            if (!(LOCKS[file] === true)) {
              _context2.next = 4;
              break;
            }

            throw new errors.LockExistsError("Lock already being held for file: ".concat(file));

          case 4:
            LOCKS[file] = true;
            closer = {
              close: function close() {
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          // eslint-disable-line require-await
                          if (LOCKS[file]) {
                            delete LOCKS[file];
                          }

                        case 1:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }))();
              }
            };
            return _context2.abrupt("return", closer);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Check if the repo in the given directory is locked.
 *
 * @param {string} dir
 * @returns {bool}
 */


exports.locked = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dir) {
    var file;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            // eslint-disable-line require-await
            file = dir + '/' + lockFile;
            log("checking lock: ".concat(file));
            return _context3.abrupt("return", Boolean(LOCKS[file]));

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x2) {
    return _ref2.apply(this, arguments);
  };
}();